import { Accordion, Disclosure, EntityChip } from '@/components/ui';
import { useExpansionMemory } from '@/components/layout/workspace/useExpansionMemory';

interface Props {
  scope: string;
  onEntityOpen: (id: string) => void;
}
export function DisclosureExamples({ scope, onEntityOpen }: Props) {
  const [single, setSingle] = useExpansionMemory(scope + '.single');
  const [group, setGroup] = useExpansionMemory(scope + '.group', ['source']);
  const [rows, setRows] = useExpansionMemory(scope + '.rows');
  return (
    <div data-slot="disclosure-examples" className="flex min-w-0 flex-col gap-6">
      <section className="min-w-0">
        <h3 className="mb-3 type-subheading">Один блок</h3>
        <Disclosure
          title="Что войдёт в проверку?"
          open={single.includes('about')}
          onOpenChange={(open) => setSingle(open ? ['about'] : [])}
          headingLevel={4}
        >
          <p>Три вымышленных источника и связи между записями. Проверка ничего не изменяет.</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <EntityChip kind="task" name="Проверка А" onClick={() => onEntityOpen('check-a')} />
          </div>
        </Disclosure>
      </section>
      <section className="min-w-0">
        <h3 className="mb-3 type-subheading">Один раздел за раз</h3>
        <Accordion
          headingLevel={4}
          value={group}
          onValueChange={setGroup}
          items={[
            {
              id: 'source',
              title: 'Источники данных',
              description: 'Три источника · примерные данные',
              content: (
                <p>
                  Каталог, список записей и список связей. Новые данные появятся после следующей проверки.
                </p>
              ),
            },
            {
              id: 'rules',
              title: 'Как проверяются связи',
              content: (
                <p>
                  У каждой связи должны быть существующие начало и конец. Совпадение названий само по себе
                  связь не создаёт.
                </p>
              ),
            },
            {
              id: 'closed',
              title: 'Настройки недоступны в образце',
              disabled: true,
              content: <p>Настройки задаёт сервис.</p>,
            },
          ]}
        />
      </section>
      <section className="min-w-0">
        <h3 className="mb-3 type-subheading">Подробности строк</h3>
        <Accordion
          headingLevel={4}
          type="multiple"
          value={rows}
          onValueChange={setRows}
          items={[
            {
              id: 'catalog',
              title: 'Каталог А',
              description: '12 записей · проверен',
              content: (
                <div className="flex flex-col gap-3">
                  <p>Все записи доступны, повторяющихся идентификаторов нет.</p>
                  <div>
                    <EntityChip kind="task" name="Запись А-12" onClick={() => onEntityOpen('record-a12')} />
                  </div>
                </div>
              ),
            },
            {
              id: 'links',
              title: 'Связи Б',
              description: '8 связей · ждут проверки',
              content: (
                <div className="flex flex-col gap-3">
                  <p>Будут проверены после каталога. Строки можно раскрыть независимо друг от друга.</p>
                  <div>
                    <EntityChip kind="task" name="Запись Б-08" onClick={() => onEntityOpen('record-b08')} />
                  </div>
                </div>
              ),
            },
          ]}
        />
      </section>
    </div>
  );
}
